import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "overflow-x-auto w-full border rounded-lg" }
const _hoisted_2 = { class: "w-max min-w-full" }
const _hoisted_3 = { class: "px-2" }
const _hoisted_4 = { class: "font-bold md:hidden mr-2" }
const _hoisted_5 = { class: "truncate flex items-center gap-2" }
const _hoisted_6 = { class: "flex flex-row justify-center items-center gap-2 mt-4 md:mt-0 whitespace-nowrap" }

import { computed } from 'vue'

import StatusDot from './components/StatusDot.vue'

interface ColumnConfig {
  key: string
  label: string
  cols?: string
  width?: string
  align?: 'left' | 'center'
}

interface RowData {
  [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableModular',
  props: {
    rows: {},
    columns: {},
    actionsLabel: {},
    actionsWidth: {}
  },
  setup(__props: any) {

const { rows, columns, actionsLabel, actionsWidth } = __props;



// `align` alinha cabeçalho E célula no mesmo eixo — sem ele o cabeçalho fica à
// esquerda enquanto a célula centraliza, e conteúdo estreito (ícone, badge) parece
// fora de eixo. Omitir a prop preserva o comportamento histórico.
const headerAlignClass = (column: ColumnConfig): string => {
  if (!column.align) return ''
  return column.align === 'center' ? 'text-center' : 'text-left'
}

const cellAlignClass = (column: ColumnConfig): string => {
  if (column.align) return column.align === 'center' ? 'justify-center' : 'justify-start'
  return column.key === 'name' ? 'justify-start' : 'justify-center'
}

const gridTemplateColumns = computed(() => {
  const colWidths = columns.map((c) => c.width || 'minmax(150px, 1fr)').join(' ')
  return `${colWidths} ${actionsWidth ?? 'auto'}`
})

const getValue = (obj: RowData, path: string): string => {
  const value = path.split('.').reduce((acc, part) => acc?.[part], obj)
  return value !== undefined && value !== null ? String(value) : '-'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "hidden md:grid gap-2 px-4 py-2 font-semibold text-sm text-black",
        style: _normalizeStyle({
          gridTemplateColumns: gridTemplateColumns.value,
          background: 'var(--Neutral-LightGray-5, #FAFAFA)'
        })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'head-' + idx,
            class: _normalizeClass(["whitespace-nowrap px-2", headerAlignClass(column)])
          }, _toDisplayString(column.label), 3))
        }), 128)),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.actionsLabel), 1)
      ], 4),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "grid gap-2 items-center py-4 px-4 text-center text-sm",
          style: _normalizeStyle({ gridTemplateColumns: gridTemplateColumns.value })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: _normalizeClass(["flex flex-row items-center whitespace-nowrap", cellAlignClass(column)])
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(column.label) + ":", 1),
              _renderSlot(_ctx.$slots, `column-${column.key}`, {
                row: row,
                value: getValue(row, column.key)
              }, () => [
                _createElementVNode("p", _hoisted_5, [
                  (column.key === 'name')
                    ? (_openBlock(), _createBlock(StatusDot, {
                        key: 0,
                        status: row.status
                      }, null, 8, ["status"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(getValue(row, column.key)), 1)
                ])
              ])
            ], 2))
          }), 128)),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "actions", {
              row: row,
              index: index
            })
          ])
        ], 4))
      }), 128))
    ])
  ]))
}
}

})